enum MortgagePurchaseType {
  ALONE = 'ALONE',
  WITH_OTHERS = 'WITH_OTHERS',
}

export default MortgagePurchaseType;
